import { render, staticRenderFns } from "./notificationsbeta.vue?vue&type=template&id=3d0e2f5c&scoped=true"
import script from "./notificationsbeta.vue?vue&type=script&lang=js"
export * from "./notificationsbeta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0e2f5c",
  null
  
)

export default component.exports